/**
 * declare permette di "aggiungere" al dizionario typescript delle keyword in modo da permettere la compilazione 
 * anche quando non sono presenti nell'environment
 */
declare var require: any; //non presente nei progetti web. In compilazione si avrebbe l'errore "Cannot find name 'require'."
declare var global: any;  //non presente nei progetti web. In compilazione si avrebbe l'errore "Cannot find name 'global'."

import { logger } from './logger';

export class Environment {

    private _environmentVariables;

    constructor(environmentVariables) {
        this._environmentVariables = environmentVariables;
    }

    getOptionalValue = (key: string) => {
        try {
            // La variabile key può contenere fino a 4 livelli di annidamento (es: key.subkey.subkey)
            const fragments = key.split(".");
            // Valore assegnato alla key specificata
            const value =
                fragments.length == 4 ? this._environmentVariables[fragments[0]][fragments[1]][fragments[2]][fragments[3]]
                    : fragments.length == 3 ? this._environmentVariables[fragments[0]][fragments[1]][fragments[2]]
                    : fragments.length == 2 ? this._environmentVariables[fragments[0]][fragments[1]]
                    : this._environmentVariables[fragments[0]];

            if (typeof value == 'undefined')
                throw new Error('key not found');

            return value;
        } catch (error) {
           return undefined;
        }
    }

    getValue = (key: string) => {
        const value = this.getOptionalValue(key);

        if(value===undefined){
            logger.error(`Environment.getValue('${key}') - not found`);
            throw new Error(`Environment.getValue('${key}') - not found`); 
        }

        return value;
    }
    
    getValues = (...keys: string[]) => {
        try {
            const keysAsArray = [].slice.call(keys);
            return keysAsArray.map(item=>this.getValue(item))
        } catch (error) {
            logger.error(`Environment.getValues('${keys}') - Error: ${error}`);
            throw error; 
        }
    }
}

/**
 * Restituisce il tipo di applicazione: 
 * - WEB
 * - DESKTOP (electron renderer ed electron main)
 * - SERVER
 * Per determinare la tipologia di app ci siamo basati sul fatto che global è not defined solo nelle applicazioni WEB mentre 
 * è presente nel renderer process delle DESKTOP APP.
 */
export const getAppType = () => {
    let isWebApp = true;

    try {
        global; //Se global non è definito si ottiene "ReferenceError: global is not defined"
        isWebApp = false;
    } catch (error) {}


    if(isWebApp) 
        return "WEB";
    else 
        return require('process').versions.hasOwnProperty("electron")?"DESKTOP":"SERVER";
}

export const isDesktopApp = (): boolean => getAppType()=="DESKTOP";
    
export const isWebApp = (): boolean => getAppType()=="WEB";

export const isServerApp = (): boolean => getAppType()=="SERVER";